// extracted by mini-css-extract-plugin
export default {"container":"bra_3YRw6","sponsor":"bra_spo_3Pnf1"};